(() => {
  const APPEARANCE = {threshold:40,overlay:0,solid:1};
  const instances = new Map();
  const attach = () => {
    instances.forEach((instance, root) => {
      instance.abort.abort();
      cancelAnimationFrame(instance.frame);
      instances.delete(root);
    });
    document.querySelectorAll('erya-reference-header').forEach(root => {
      const abort = new AbortController();
      const instance = {abort,frame:0};
      instances.set(root, instance);
      const {signal} = abort;
      const update = () => {
        instance.frame = 0;
        const firstHero = document.querySelector('#MainContent>.shopify-section:first-child')?.querySelector('erya-fullwidth-hero');
        const enabled = root.dataset.homeOverlay === 'true' && firstHero?.dataset.headerOverlay === 'true';
        root.dataset.overlayActive = String(enabled);
        const threshold = Number(root.dataset.scrollThreshold) || APPEARANCE.threshold;
        const stage = !enabled || window.scrollY > threshold || root.querySelector('details[open]')
          ? APPEARANCE.solid : APPEARANCE.overlay;
        root.dataset.headerSurface = stage === APPEARANCE.overlay ? 'overlay' : 'solid';
      };
      const schedule = () => {
        if (!instance.frame) instance.frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, {signal,passive:true});
      window.addEventListener('resize', schedule, {signal,passive:true});
      root.addEventListener('toggle', schedule, {signal,capture:true});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, {once:true});
  else attach();
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:unload', attach);
})();
